import Dynamic from '@base/Dynamic/Dynamic';
import styled from '@emotion/styled';
import { useLocalLoginInfo } from './Context/LoginLocalInfo';
import useLoginStepFlags from './utils/hooks/useLoginStepFlags';

const EnterNumberStep = Dynamic(() => import('./EnterNumberStep'));
const EnterEmailStep = Dynamic(() => import('./EnterEmailStep'));
const EnterEmailOtpStep = Dynamic(() => import('./EnterEmailOtpStep'));
const EnterOtpStep = Dynamic(() => import('./EnterOtpStep'));
const EnterPasswordStep = Dynamic(() => import('./EnterPasswordStep'));
const ConfirmAgeStep = Dynamic(() => import('./ConfirmAgeStep'));
const EnterNumberOtpStep = Dynamic(() => import('./EnterNumberOtpStep'));
const NewEnterEmailOTPStep = Dynamic(() => import('./NewEnterEmailOTPStep'));
const UpdateDetailsStep = Dynamic(() => import('./UpdateDetailsStep'));
const RegisterWithEmailOutsideIndia = Dynamic(() =>
  import('./RegisterWithEmailOutsideIndia')
);

const Container = styled.div`
  background: white;
  min-width: 480px;
  padding: 40px;
  border-radius: 16px;
  border: 1px solid var(--color-divider);

  @media (max-width: 480px) {
    min-width: 320px;
    max-width: 480px;
    padding: 20px;
    border-radius: 12px;
  }
`;

const LoginUI = () => {
  const {
    showEmailStep,
    showOutsideIndiaRegistrationProcess,
    showFirstStep,
    showAgeStep,
    showPhoneOTPStep,
    showEmailOTPStep,
    showEnterPasswordStep,
    showUpdateDetailsStep
  } = useLoginStepFlags();
  const { IsNewLoginModal, country } = useLocalLoginInfo();
  const isOutsideIndia = country ? country?.code !== 'IN' : false;
  const { countries, isTTU } = useLocalLoginInfo();

  const renderFirstStepForModal = () => {
    if (showEmailStep) return <NewEnterEmailOTPStep />;
    return <EnterNumberOtpStep />;
  };

  if (!isOutsideIndia && IsNewLoginModal && !isTTU) {
    return (
      <>
        {(showFirstStep ||
          ((showPhoneOTPStep || showEmailOTPStep) && !showUpdateDetailsStep)) &&
          renderFirstStepForModal()}
        {showUpdateDetailsStep && <UpdateDetailsStep />}
      </>
    );
  }

  const renderFirstStep = () => {
    if (showEmailStep) return <EnterEmailStep />;
    return <EnterNumberStep />;
  };

  if (!countries.length) return null;
  if (showOutsideIndiaRegistrationProcess)
    return <RegisterWithEmailOutsideIndia />;
  return (
    <Container>
      {showFirstStep && renderFirstStep()}
      {showAgeStep && <ConfirmAgeStep />}
      {showPhoneOTPStep && <EnterOtpStep />}
      {showEmailOTPStep && <EnterEmailOtpStep />}
      {showEnterPasswordStep && <EnterPasswordStep />}
    </Container>
  );
};

export default LoginUI;
